import { NavLink } from "react-router-dom";
import styles from "./Footer.module.scss";
import { TelegramIcon } from "@/pages/MainPage/ui/assets/icons/telegram-icon";
import { AppRoutes, getRouteTermsAndConditions } from "@/shared/config/router";

export const Footer = () => {
    return (
        <div className={styles.container}>
            <div className={styles.footer}>
                <div className={styles.column}>
                    <div className={styles.columnTitle}>
                        Dr. Torsunov Corporation
                    </div>
                    <div className={styles.columnText}>
                        <NavLink to={getRouteTermsAndConditions()}>
                            Terms and Conditions
                        </NavLink>
                    </div>
                </div>
                <div className={styles.column}>
                    <div className={styles.columnTitle}>Get in touch</div>
                    <div className={styles.contactsWrapper}>
                        <div className={styles.columnText}>
                            <a href="mailto:info@torsunov.com">
                                info@torsunov.com
                            </a>
                        </div>
                        <div className={styles.columnText}>
                            <a
                                href="tel:+16136170199"
                                className="text-blue-600 underline"
                            >
                                +16136170199
                            </a>
                        </div>
                        <div className={styles.columnText}>
                            <a
                                href="https://t.me/dmitriyt21"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span>
                                    <TelegramIcon />
                                </span>
                                <span className={styles.marginLeft}>
                                    @dmitriyt21
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
